(function () {
    'use strict';

    angular.module("imApp").factory("pickJobGrpBatchesPickerService", ['$ihttp', function ($ihttp) {
        let service = {
            getPickJobGroupBatchesPicker: function (parms) {
                return $ihttp.post({
                    method: 2330,
                    parameters: parms || {}
                });
            },
            listPickJobGroupBatchesPickers: function (parms) {
                return $ihttp.post({
                    method: 2331,
                    parameters: parms || {}
                });
            }
        };

        return service;
    }]);
})();
